import { useFetcher, useSearchParams } from '@remix-run/react';
import { useEffect } from 'react';
import { losseLoader } from './useLosseData';
export default function useLosseZoekenMoek(queryName = 'Search', queryParameter = 'q') {
    const [searchParams, setSearchParams] = useSearchParams();
    const fetcher = useFetcher();
    function next() {
        var _a;
        if (!fetcher.data)
            return;
        searchParams.delete('before');
        searchParams.set('after', ((_a = fetcher.data.pageInfo) === null || _a === void 0 ? void 0 : _a.endCursor) || '');
        setSearchParams(searchParams);
    }
    function prev() {
        var _a;
        if (!fetcher.data)
            return;
        searchParams.delete('after');
        searchParams.set('before', ((_a = fetcher.data.pageInfo) === null || _a === void 0 ? void 0 : _a.endCursor) || '');
        setSearchParams(searchParams);
    }
    useEffect(() => {
        if (!searchParams.has(queryParameter))
            return;
        const query = losseLoader({
            name: queryName,
            variables: {
                search: searchParams.get(queryParameter) || '',
                after: searchParams.get('after') || ''
            }
        });
        fetcher.load(query);
    }, [searchParams.get(queryParameter), searchParams.get('after')]);
    return [
        fetcher.data === undefined ? 'loading' : fetcher.state,
        fetcher.data,
        searchParams.get(queryParameter) || undefined,
        next,
        prev
    ];
}
export const losseZoekenMoekFragment = (contentTypes) => `
  query ($search: String!, $after: String = "") {
    Search: contentNodes(
      first: 10,
      after: $after,
      where: {search: $search, contentTypes: [${contentTypes.map(({ name }) => name.toUpperCase())}]}
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          contentTypeName
          ${contentTypes.map(({ fragment, fields }) => `
            ... on ${fragment} {
              ${fields ||
    `
                id
                title
                uri
              `}
            }
          `)}
        }
      }
    }
  }
`;
